var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTreandsPieIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6933 9.54533C29.8972 10.4401 30.0001 11.3549 30.0001 12.2726H17.7275V0C20.5084 -1.10038e-05 23.2069 0.944447 25.3809 2.67864C27.5548 4.41284 29.0753 6.83395 29.6933 9.54533ZM26.8747 9.54533C26.4219 8.02627 25.5979 6.64392 24.477 5.52308C23.3562 4.40224 21.9738 3.57822 20.4548 3.12541V9.54533H26.8747Z",
    fill: "#F0C52F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 17.7296C-7.29416e-06 15.8862 0.415253 14.0665 1.21494 12.4056C2.01463 10.7447 3.17821 9.28527 4.61926 8.13571C6.06031 6.98614 7.74181 6.17597 9.5389 5.76536C11.336 5.35475 13.2025 5.35425 14.9998 5.76389V15.0024H24.2383C24.6222 16.6866 24.6461 18.4329 24.3086 20.1271C23.9712 21.8212 23.2798 23.425 22.2799 24.8336C21.2799 26.2422 19.9939 27.4238 18.5059 28.3012C17.0179 29.1785 15.3614 29.7319 13.6448 29.925C11.9282 30.1182 10.1902 29.9468 8.54438 29.422C6.89859 28.8972 5.38212 28.031 4.09416 26.8798C2.8062 25.7287 1.77576 24.3186 1.07025 22.7418C0.36473 21.165 2.99924e-05 19.4571 0 17.7296ZM21.5493 17.7296H12.2726V8.45159C10.4375 8.45132 8.64353 8.99523 7.11758 10.0146C5.59163 11.0339 4.40223 12.4828 3.69978 14.1781C2.99734 15.8735 2.81341 17.739 3.17125 19.5389C3.52909 21.3387 4.41263 22.992 5.71014 24.2897C7.00764 25.5874 8.66083 26.4712 10.4606 26.8293C12.2604 27.1874 14.126 27.0038 15.8214 26.3016C17.5169 25.5994 18.966 24.4102 19.9855 22.8844C21.0051 21.3586 21.5493 19.5647 21.5493 17.7296Z",
    fill: "#F0C52F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreandsPieIcon);
export default __webpack_public_path__ + "static/media/Treands_Pie_Icon.3dfc786e09fe43cdc7b06cea49e9bc50.svg";
export { ForwardRef as ReactComponent };